import getToken from '../auth/getToken';

const API = () => process.env.REACT_APP_BACKEND_URL;
const SCOPE = () => [`${process.env.REACT_APP_CLIENT_ID}/.default`];

async function authHeader(instance) {
  const token = await getToken(instance, SCOPE());
  return { Authorization: `Bearer ${token}` };
}

export async function fetchTranscriptionResult(instance, jobId) {
  const response = await fetch(`${API()}/transcription_result/${jobId}`, {
    headers: await authHeader(instance),
  });
  if (!response.ok) {
    throw new Error('Fehler beim Abrufen der Transkriptionsergebnisse');
  }
  return response.json();
}

export async function dismissSpeakerAssistant(instance, jobId) {
  const response = await fetch(
    `${API()}/transcription_result/${jobId}/speaker_assistant_dismissed`,
    {
      method: 'POST',
      headers: await authHeader(instance),
    },
  );
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return response.json();
}

export async function updateSegmentText(instance, jobId, segmentIndex, text) {
  const response = await fetch(
    `${API()}/transcription_result/${jobId}/segments/${segmentIndex}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeader(instance)),
      },
      body: JSON.stringify({ text }),
    },
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return data;
}

/**
 * Split a segment at `wordIndex` and assign `newSpeaker` to the right half.
 * Returns the full updated segments array + transcription so the caller can
 * atomically swap state without a separate re-fetch.
 */
export async function splitSegmentAtWord(instance, jobId, segmentIndex, wordIndex, newSpeaker) {
  const response = await fetch(
    `${API()}/transcription_result/${jobId}/segments/${segmentIndex}/split`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeader(instance)),
      },
      body: JSON.stringify({ word_index: wordIndex, new_speaker: newSpeaker }),
    },
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return data;
}
